import { createIcon } from '@chakra-ui/react'

export const FacebookIcon = createIcon({
  displayName: 'FacebookIcon',
  viewBox: '0 0 22 22',
  d: 'M22 11.067C22 4.955 17.075 0 11 0S0 4.955 0 11.067C0 16.591 4.023 21.17 9.281 22v-7.734H6.488v-3.199h2.793V8.63c0-2.774 1.643-4.306 4.155-4.306 1.204 0 2.462.216 2.462.216v2.724h-1.387c-1.366 0-1.792.853-1.792 1.728v2.076h3.05l-.487 3.2h-2.563V22C17.977 21.17 22 16.591 22 11.067Z',
})
